import { render, staticRenderFns } from "./GySteps.vue?vue&type=template&id=3059b09e&"
import script from "./GySteps.vue?vue&type=script&lang=js&"
export * from "./GySteps.vue?vue&type=script&lang=js&"
import style0 from "./GySteps.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports